"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  width: 100%;\n  max-width: 100%;\n  min-height: 40px;\n  padding: 16px;\n  box-sizing: border-box;\n  word-break: break-all;\n  word-break: break-word;\n  border-radius: 8px;\n  background: #fff;\n  cursor: initial;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);\n\n  @media (min-width: 500px) {\n    width: 304px;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var _default = _styledComponents["default"].div(_templateObject());

exports["default"] = _default;